import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LaboratoryComponent} from './laboratory/laboratory.component';
import {SearchTestResultComponent} from './laboratory/search-test-result/search-test-result.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PRODUCTION_PROVIDERS} from './app.provider';
import {HttpClientModule} from '@angular/common/http';
import {Ng2Webstorage} from 'ngx-webstorage';
import {DocumentsComponent} from './documents/documents.component';
import {DocumentThumbnailComponent} from './documents/document-thumbnail/document-thumbnail.component';
import {SvgPathDirective} from './shared/directives/svg/svg-path.directive';
import {Ng2IziToastModule} from 'ng2-izitoast';
import {LoaderComponent} from './loader.component';
import {ScrollOffsetDirective} from './shared/directives/scroll-offset.directive';
import {RecaptchaModule} from 'angular-google-recaptcha';
import { RadiographyComponent } from './radiography/radiography.component';
import { SearchImagingResultComponent } from './radiography/search-imaging-result/search-imaging-result.component';
import { RadiographyPrintComponent } from './radiography/radiography-print/radiography-print.component';

@NgModule({
  declarations: [
    AppComponent,
    LaboratoryComponent,
    SearchTestResultComponent,
    DocumentsComponent,
    DocumentThumbnailComponent,
    SvgPathDirective,
    LoaderComponent,
    ScrollOffsetDirective,
    RadiographyComponent,
    SearchImagingResultComponent,
    RadiographyPrintComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    Ng2IziToastModule,
    Ng2Webstorage,
    RecaptchaModule.forRoot({
      siteKey: '6Lf2y6YUAAAAAEBczeIby3vMHLWlLbQfWcpXItnL'
    }),
  ],
  providers: [
    PRODUCTION_PROVIDERS,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
